/* Candidate Outreach · Recruitment Stap 3 — same Unified Inbox view as Sales,
 * scoped to the candidate (recruit) pillar.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../Dashboard";
import UnifiedInbox from "@/components/inbox/UnifiedInbox";
import ReplyRatePanel from "@/components/inbox/ReplyRatePanel";
import AiCostPanel from "@/components/inbox/AiCostPanel";
import DraftBatchPanel from "@/components/inbox/DraftBatchPanel";
import BestSendTimePanel from "@/components/inbox/BestSendTimePanel";
import FollowupPanel from "@/components/inbox/FollowupPanel";
import CollapsibleStats from "@/components/inbox/CollapsibleStats";

export default function CandidateOutreach() {
    const { t } = useTranslation();
    return (
        <PageHeader
            title={t("outreach_recruit.title")}
            subtitle={t("outreach_recruit.subtitle")}>
            <CollapsibleStats>
                <DraftBatchPanel pillar="recruit" />
                <FollowupPanel />
                <BestSendTimePanel />
                <ReplyRatePanel />
                <AiCostPanel />
            </CollapsibleStats>
            <UnifiedInbox pillar="recruit" />
        </PageHeader>
    );
}
